$(document).ready(function() {
$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  
  
  $('.announcementbar-messgaes').owlCarousel({
    loop: true,
    responsiveClass: true,
    autoplay: true,
    dots: false,
    items: 1
  });
  
  $('.featured_collection_carousel, .recently-viewed').owlCarousel({
    loop: true,
    responsiveClass: true,
    autoplay: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: false,
        stagePadding: 40,
        margin: 20
      },
      600: {
        items: 4,
        nav: false
      },
      1600: {
        items: 5,
        nav: false
      }
    }
  });
});
$(document).ready(function () {
    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
    
    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth < 768) {
            $(document).ready(function() {
              $('.shippingshow-section').owlCarousel({
                loop: false,
                responsiveClass: true,
                responsive: {
                  0: {
                    items: 1,
                    nav: true
                  },
                  600: {
                    items: 1,
                    nav: false
                  },
                  1600: {
                    items: 1,
                    nav: false,
                    loop: false
                  }
                }
              });
            });
        }
    }
  
    $('.tabs-nav li a').click(function(){
      $('.tab-content').hide();
      $('.tabs-nav li a.active').removeClass('active');
      $(this).addClass('active');
      var panel = $(this).attr('href');
      $(panel).fadeIn();
      return false;  // prevents link action
    });  // end click 
    $('.tabs-nav li:first a').click();
  
  $('#createacc').click(function() {
  	$('#sign-up-elevate').fadeIn();
    $('#login-elevate').hide();
  });
  $('#alreadyacc_signin').click(function() {
  	$('#sign-up-elevate').hide();
    $('#login-elevate').fadeIn();
  });
  
  $('.password-show .eye').click(function() {
    $(this).hide();
    $('.closeeye').show();
  	$('input.auth-input.pass').attr('type', 'text');
  });
  
  $('.password-show .closeeye').click(function() {
    $(this).hide();
    $('.eye').show();
  	$('input.auth-input.pass').attr('type', 'password');
  });
  
  $('#RecoverPassword').click(function(e) {
  	e.preventDefault();
    $('#RecoverPasswordForm').removeClass('hide');
    $('#RecoverPasswordForm').show();
    $('#login-elevate').hide();
  });
  
  
  $('#HideRecoverPasswordLink').click(function(e) {
  	e.preventDefault();
    $('#RecoverPasswordForm').addClass('hide');
    $('#RecoverPasswordForm').hide();
    $('#login-elevate').show();
  });
  
  $('form#localization_formtoolbarmenu .disclosure__toggle').on('click', function() {
  	console.log('here');
    $('#CurrencyList-toolbarmenu').toggleClass('disclosure-list--visible');
  });
  
  
  $('form#localization_formtoolbarmenu .disclosure-list__option').on('click', function(e) {
    e.preventDefault();
    var a = $(this).attr('data-value');
    
    $('input[name="country_code"]').val(a);
    $(this).parent().parent().parent().parent().parent().submit();
  });
 
    $('.togglemodalclearpay').click(function() {
      $('.afterpay-modal-overlay').addClass('visible');
    });
  
    $('.afterpay-close-button').click(function() {
      $('.afterpay-modal-overlay').removeClass('visible');
    });    

  $(document).on('click', '#afterpay-modal-component .visible', function() {
    $('.afterpay-modal-overlay').removeClass('visible');
  });
});